import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63b8c8c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-warning alert-sm"
}
const _hoisted_7 = { class: "modal-footer" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

import { computed, ref } from 'vue'
import { FamilyRelationshipRole, ViewFamily } from '@/rd/ResearchDataModel'
import { NewProfileRelationship, setProfileSpouseAsync } from './ProfileManager'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { Modal } from 'bootstrap'
import ProfileCreatorSelector from './ProfileCreatorSelector.vue'
import { CompositeId } from '@/rd/CompositeId'
import { LoadMode } from '@/util/AsyncData'
import { useViewFamilyStore } from '@/rd/ViewFamilyStore'
import { useAssertionStore } from '@/rd/AssertionStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSpouseRelationshipModal',
  props: {
    asChild: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  open,
})

const viewPersonStore = useViewPersonStore()
const viewFamilyStore = useViewFamilyStore()
const assertionStore = useAssertionStore()

const profileGroupIdRef = ref<string>()
const viewFamilyRef = ref<ViewFamily>()
const spouseRoleRef = ref(FamilyRelationshipRole.Father)
const useExistingRef = ref(false)
const newSpouseIdRef = ref<string>()
const detailsLoadedRef = ref(false)
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()
const creatorSelectorRef = ref<InstanceType<typeof ProfileCreatorSelector>>()

const titleRef = computed(() => {
  if (props.asChild) {
    if (viewFamilyRef.value?.getSpouseId(spouseRoleRef.value))
      return spouseRoleRef.value == FamilyRelationshipRole.Father ? 'Change father' : 'Change mother'

    return spouseRoleRef.value == FamilyRelationshipRole.Father ? 'Add father' : 'Add mother'
  }
  return 'Change spouse'
})
const personRoleRef = computed(() => spouseRoleRef.value == FamilyRelationshipRole.Father ? FamilyRelationshipRole.Mother : FamilyRelationshipRole.Father)
const personIdRef =  computed(() => viewFamilyRef.value?.getSpouseId(personRoleRef.value))
const spouseRelRef = computed(() => spouseRoleRef.value == FamilyRelationshipRole.Father ? NewProfileRelationship.Husband : NewProfileRelationship.Wife)
const oldSpouseIdRef = computed(() => viewFamilyRef.value?.getSpouseId(spouseRoleRef.value))
const profileFamilyAssertionsRef = computed(() => {
  const profileFamilyId = viewFamilyRef.value?.matchIds.find(id => CompositeId.hasGroupId(id, profileGroupIdRef.value!))
  return assertionStore.getLoadedForFamily(profileFamilyId)
})
const hasDetailsRef = computed(() => detailsLoadedRef.value && profileFamilyAssertionsRef.value.length > 0)
const canChangeRef = computed(() => creatorSelectorRef.value?.isValid && !busyRef.value)

function open(profileGroupId: string, viewFamily: ViewFamily, spouseRole: FamilyRelationshipRole) {
  if (spouseRole == FamilyRelationshipRole.Child)
    throw `Unexpected spouse role ${spouseRole}`

  if (modalRef.value) {
    profileGroupIdRef.value = profileGroupId
    viewFamilyRef.value = viewFamily
    spouseRoleRef.value = spouseRole
    creatorSelectorRef.value?.reset()

    detailsLoadedRef.value = false
    viewFamilyStore.ensureAssertionsLoadedAsync(viewFamily.id!).then(() => {
      detailsLoadedRef.value = true
    })

    Modal.getOrCreateInstance(modalRef.value)?.show()
  }
}

function validateExisting(personId: string) {
  if (personId && personId == oldSpouseIdRef.value) {
    return 'This is the current spouse.'
  }
}

async function changeSpouse(e: Event) {
  e.preventDefault()

  busyRef.value = true
  try {
    const profileFamilyId = viewFamilyRef.value?.matchIds.find(id => CompositeId.hasGroupId(id, profileGroupIdRef.value!))
    if (!profileFamilyId)
      throw `Profile family in group ${profileGroupIdRef.value} not found`

    const viewSpouseId = await creatorSelectorRef.value?.getOrCreateProfileAsync()
    const viewSpouse = await viewPersonStore.getAsyncPerson(viewSpouseId, LoadMode.EnsureLoaded)?.whenLoadCompleted
    if (!viewSpouse)
      throw `Spouse ${viewSpouseId} not found`

    await setProfileSpouseAsync(profileFamilyId, viewSpouse.id!, spouseRoleRef.value)

    Modal.getOrCreateInstance(modalRef.value!)?.hide()
  }
  finally {
    busyRef.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    ref_key: "modalRef",
    ref: modalRef,
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(titleRef.value), 1),
          _createElementVNode("button", _mergeProps({
            type: "button",
            class: "btn-close"
          }, { disabled: busyRef.value }, {
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }), null, 16)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (detailsLoadedRef.value && hasDetailsRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Existing family details will remain associated with this relationship even if the spouse is changed. "))
            : _createCommentVNode("", true),
          _createVNode(ProfileCreatorSelector, {
            ref_key: "creatorSelectorRef",
            ref: creatorSelectorRef,
            relationship: spouseRelRef.value,
            "related-item-id": personIdRef.value,
            "use-existing": useExistingRef.value,
            "onUpdate:useExisting": _cache[0] || (_cache[0] = ($event: any) => ((useExistingRef).value = $event)),
            "existing-person-id": newSpouseIdRef.value,
            "onUpdate:existingPersonId": _cache[1] || (_cache[1] = ($event: any) => ((newSpouseIdRef).value = $event)),
            "validate-existing": validateExisting
          }, null, 8, ["relationship", "related-item-id", "use-existing", "existing-person-id"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            disabled: !canChangeRef.value,
            onClick: changeSpouse
          }, " Change ", 8, _hoisted_8),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal"
          }, " Cancel ", 8, _hoisted_9)
        ])
      ])
    ])
  ], 512))
}
}

})